import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from "@/components/ui/resizable";
import { EditorPanel } from "@/components/EditorPanel";
import { OutputPanel } from "@/components/OutputPanel";
import { useSandbox } from "@/hooks/useSandbox";

export function WorkspacePanel() {
  const { output, isRunning, run } = useSandbox();

  return (
    <section
      aria-label="Coding"
      className="h-175 min-h-0 min-w-0 overflow-hidden border-t bg-panel lg:h-full lg:border-t-0 lg:border-l"
    >
      <ResizablePanelGroup orientation="vertical">
        <ResizablePanel defaultSize="60%" minSize="240px">
          <EditorPanel onRun={run} isRunning={isRunning} />
        </ResizablePanel>
        <ResizableHandle
          withHandle
          aria-label="Resize editor and output"
          title="Drag up or down to resize; use arrow keys when focused"
          className="shrink-0 cursor-row-resize border-y border-divider bg-inset transition-colors hover:bg-divider focus-visible:bg-divider focus-visible:ring-grip aria-[orientation=horizontal]:h-3 [&>div]:h-10 [&>div]:w-1 [&>div]:bg-grip"
        />
        <ResizablePanel defaultSize="40%" minSize="100px">
          <OutputPanel output={output} isRunning={isRunning} />
        </ResizablePanel>
      </ResizablePanelGroup>
    </section>
  );
}
